import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-188" data-mp="27m281jbinr8p">
      <div className="mx-auto w-full max-w-3xl" data-id="element-189" data-mp="27nlopb1344b0">
        <SectionHeading eyebrow="Riconoscimento" title="Ti riconosci in una di queste situazioni?" subtitle="Se rispondi SÌ anche solo a una… questo sistema è stato creato per te." data-id="element-190" data-mp="22v2acbukp555" />

        <ul className="mt-8 space-y-3" data-id="element-191" data-mp="2ckludku0v51l">
          {painPoints.map(point => <li key={point.text} className="flex gap-3 rounded-2xl border border-ink-line bg-ink-soft p-4" data-id="element-192" data-mp="2qlg54a4jli3f">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-193" data-mp="2mhgq5vywurc6">
                {point.emoji}
              </span>
              <p className="text-[14.5px] leading-snug text-cream/80 sm:text-[15px]" data-id="element-194" data-mp="s5jz444drnhn">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mt-8 rounded-2xl border border-gold/25 bg-ink-soft p-5 text-center" data-id="element-195" data-mp="1n5qn905byhwc">
          <p className="font-display text-xl font-bold text-cream" data-id="element-196" data-mp="1s76b0zyw72if">
            E non dovrebbe essere così.
          </p>
          <p className="mt-2 text-[14.5px] leading-relaxed text-cream/65" data-id="element-197" data-mp="21wpqdvnece8j">
            Perché il problema non è la tua esperienza. Il problema è che nessuno
            ti ha mai insegnato un sistema per prendere decisioni cliniche in
            modo strutturato.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-198" data-mp="2az8t8fr6mqus">
          <CTAButton label="Voglio un sistema strutturato" data-id="element-199" data-mp="2fxip6skqdvhg" />
        </div>
      </div>
    </section>;
}